import { CidadaoAtendimentoSelectFieldModel, LocalAtendimentoSelectFieldModel } from 'components/form'
import { LotacaoAndEstagioSelectFieldModel } from 'components/form/field/select/LotacaoAndEstagioSelectField/LotacaoAndEstagioSelectField'
import { RegistroTardioJustificativaEnum, StatusAtendimento } from 'graphql/types.generated'

const LOCAL_ATENDIMENTO_UBS_ID = '1'
const LOCAL_ATENDIMENTO_UBSI_ID = '16'
const LOCAL_ATENDIMENTO_UBSI_FLUVIAL_ID = '17'
const LOCAL_ATENDIMENTO_SEDE_POLO_BASE_TIPO_I_ID = '18'
export const localAtendimentoComJustificativa = new Set<string>([
  LOCAL_ATENDIMENTO_UBS_ID,
  LOCAL_ATENDIMENTO_UBSI_ID,
  LOCAL_ATENDIMENTO_UBSI_FLUVIAL_ID,
  LOCAL_ATENDIMENTO_SEDE_POLO_BASE_TIPO_I_ID,
])

export interface RegistroTardioFormModel {
  atendimentoId?: string
  cidadao?: CidadaoAtendimentoSelectFieldModel
  lotacao?: LotacaoAndEstagioSelectFieldModel
  dataAtendimento?: LocalDate
  horaAtendimento?: string
  localAtendimento?: LocalAtendimentoSelectFieldModel
  justificativa?: RegistroTardioJustificativaEnum
}

export interface UltimoAtendimentoProfissionalCidadaoModel {
  finalizadoEm?: Instant
  lotacao: {
    cbo: {
      nome: string
    }
    profissional: {
      nome: string
    }
  }
}

export const STATUS_REGISTRO_FINALIZADO = [
  StatusAtendimento.AGUARDANDO_ATENDIMENTO,
  StatusAtendimento.ATENDIMENTO_REALIZADO,
]
